import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Arrow Down"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera-lock',
    templateUrl: './icon-camera-lock.component.html',
    styleUrls: ['./icon-camera-lock.component.scss'],
    standalone: false
})
export class IconCameraLockComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
